<template>
	<b-container>
		<transition name="fade">
			<!-- if data not ready -->
			<!-- show loader -->
			<pageLoader key="apt-show-loader-view" v-if="$wait.is('loading apt')"></pageLoader>

			<!-- else data ready -->
			<!-- show data -->
			<!-- jumbotron -->
			<b-jumbotron
				v-else-if="(Object.keys(apt).length > 0)"
				key="apt-edit-data-view"
				bg-variant="light"
				text-variant="dark"
				class="mt-4 py-2 px-0"
				header-level="4"
				header-tag="h6"
			>
				<!-- header -->
				<template slot="header" title="template name">
					<span class="text-shadow text-primary">{{ apt.name }}</span>
				</template>

				<!-- current status -->
				<b-row style="margin-top:-20px;">
					<b-col>
						<hr style="margin-bottom:0;border-top: 1px solid rgba(39, 162, 252, 0.6);" />
					</b-col>
					<b-col cols="auto" class="align-self-center">
						<div class="d-flex flex-column">
							<b-form-checkbox
								v-model="form.enabled"
								name="enabled"
								switch
								size="lg"
								id="enabled"
								class="ml-auto"
								:state="isAPTEnabled || null"
								title="disable or enable this template"
							></b-form-checkbox>
							<p
								:class="getBorderColor"
								class="ml-auto mb-0"
							>The Template is {{ isAPTEnabled ? "Enabled" : "Disabled" }}</p>
						</div>
					</b-col>
				</b-row>

				<!-- description -->
				<b-row style="margin-bottom:30px;margin-top:-30px;">
					<b-col>
						<small>
							<em class="pl-2 text-muted text-shadow">{{ form.description }}</em>
						</small>
					</b-col>
				</b-row>

				<!-- form -->
				<b-form @submit.stop.prevent="onSubmit" @reset.prevent="onReset" class="mt-2">
					<fieldset>
						<b-card
							bg-variant="white"
							border-variant="white"
							text-variant="dark"
							class="py-3 mb-3 shadow-sm"
						>
							<b-form-row>
								<b-col cols="12" sm="12" md="10" lg="6" class="plaintext-input">
									<!-- language -->
									<b-form-group
										label-cols-sm="3"
										label-cols-md="5"
										label-cols-lg="5"
										label-cols-xl="4"
										label-align="left"
										label-align-sm="right"
										label="Language:"
									>
										<b-form-input
											id="language"
											type="text"
											plaintext
											class="rounded"
											v-model="apt.language.name"
										/>
									</b-form-group>
								</b-col>
							</b-form-row>
							<!-- list of availables apTemplates (by lang) -->

							<!-- description -->
							<b-form-row>
								<b-col cols="12" sm="12" md="10" lg="6">
									<b-form-group
										label-cols-sm="3"
										label-cols-md="5"
										label-cols-lg="5"
										label-cols-xl="4"
										label-align="left"
										label-align-sm="right"
										label="Description:"
										label-for="description"
									>
										<b-form-textarea type="text" name="description" v-model.trim="form.description" />
									</b-form-group>
								</b-col>
							</b-form-row>

							<!-- closure only, w/o work-report -->
							<b-form-row>
								<b-col cols="12" sm="12" md="10" lg="6">
									<b-form-group
										label-cols-sm="3"
										label-cols-md="5"
										label-cols-lg="5"
										label-cols-xl="4"
										label-align="left"
										label-align-sm="right"
										label="Closure only:"
										label-for="closure-only"
									>
										<div class="pt-1">
											<b-form-checkbox
												v-model="form.closureOnly"
												name="closure-only"
												id="closure-only"
												switch
												size="lg"
											>
												<template slot="first">Closure only:</template>
											</b-form-checkbox>
										</div>
									</b-form-group>
								</b-col>
							</b-form-row>
						</b-card>
						<!--

							region block

						-->
						<!-- loop regions -->
						<!-- drag and drop -->
						<b-tabs
							align="right"
							v-model="tabIndex"
							active-nav-item-class="shadow-sm border-white text-warning"
							nav-class="border-0"
							nav-wrapper-class="tab-select-wrapper"
						>
							<!-- work-report tab -->
							<b-tab title="Work Report">
								<template v-slot:title>
									<font-awesome-icon :icon="['far', 'file-alt']" />&nbsp;Work Report
								</template>

								<draggable
									v-bind:list="form.regions"
									handle=".ddMoveRIcon"
									group="regions"
									@end="regionPositionMoved"
									@start="draggingRegion"
									ghost-class="ghost"
								>
									<!-- regions  -->
									<regionEdit
										v-bind:class="{ 'region-is-moving': draggingRegions }"
										v-for="(region, index) in form.regions"
										:region="region"
										:language="apt.language"
										:questions="questionsByRegion[region.id]"
										:key="'region-' + index"
										@questionsOrderChanged="doUpdateQuestionsOrder"
										@questionsAddedRemoved="doAddQuestion"
										@removeMe="doRemoveRegion"
										class="shadow-sm region-container"
									></regionEdit>

									<!-- Add Region Button -->
									<b-form-group v-if="form.regions.length == 0" key="no-region-alert">
										<b-form-row>
											<!-- atm there is no regions, alert with create_region btn inside  -->
											<b-col cols="12">
												<b-card>
													<b-card-title title-tag="h3" class="text-primary">Region</b-card-title>
													<b-alert variant="warning" show class="text-center">
														<span>
															<font-awesome-icon
																:icon="['fas', 'exclamation']"
																title="click to add new Region to the Template"
																fixed-width
															/>&nbsp;There is no region, you can add one by clicking on
														</span>
														<b-button @click.prevent="doAddRegion" variant="light" class="mx-2">
															<span v-if="cratingRegion">
																<font-awesome-icon
																	:icon="['fas', 'minus']"
																	title="click to add new Region to the Template"
																	fixed-width
																/>&nbsp;Cancel
															</span>
															<span v-else>
																<font-awesome-icon
																	:icon="['fas', 'plus']"
																	title="click to add new Region to the Template"
																	fixed-width
																/>&nbsp;Add New Region
															</span>
														</b-button>&nbsp;button
													</b-alert>
												</b-card>
											</b-col>
										</b-form-row>
									</b-form-group>
									<!-- just add-region-button, the regions already exist  -->
									<b-form-group v-else key="add-region-btn" class="mt-3 mb-0 p-2 shadow-sm bg-white rounded">
										<b-form-row>
											<b-col class="add-region-btn" cols="12" sm="6" md="5" lg="3" xl="3">
												<b-button @click.prevent="doAddRegion" variant="info" block>
													<span v-if="cratingRegion">
														<font-awesome-icon
															:icon="['fas', 'minus']"
															title="click to add new Region to the Template"
															fixed-width
														/>&nbsp;Cancel
													</span>
													<span v-else>
														<font-awesome-icon
															:icon="['fas', 'plus']"
															title="click to add new Region to the Template"
															fixed-width
														/>&nbsp;Add New Region
													</span>
												</b-button>
											</b-col>
										</b-form-row>
									</b-form-group>
									<!-- end new region -->

									<transitionExpand>
										<!-- clicked on new region, show new region form -->
										<regionCreateForm v-show="cratingRegion" @storeNewregion="doStoreNewRegion"></regionCreateForm>
									</transitionExpand>
								</draggable>
							</b-tab>

							<!-- closure tab -->
							<b-tab title="Closure">
								<template v-slot:title>
									<font-awesome-icon :icon="['fas', 'chart-pie']" />&nbsp;Closure
								</template>
								<!-- already selected cqs -->
								<b-card
									bg-variant="white"
									border-variant="white"
									text-variant="dark"
									class="shadow-sm top-right-no-radius"
								>
									<b-card-title title-tag="h3" class="text-primary">Closure Questions</b-card-title>

									<!-- the closure questions that have been assigned to template -->
									<CQAssignetToTemplate
										@deassign="deAssignCQ"
										@closureQuestionsOrderChanged="doUpdateCLosureQuestionsOrder"
										:questions="form.closureQuestions"
									></CQAssignetToTemplate>
									<!-- 
												
												fetch available closure questions 
												
									-->
									<b-row>
										<b-col cols="12">
											<b-button
												v-b-toggle.my-collapse
												@click="getAvailableClosureQuestions"
												variant="light"
												class="mt-3"
											>
												<v-wait for="loading cq">
													<template slot="waiting">
														<span>
															<font-awesome-icon :icon="['fas', 'circle-notch']" spin />&nbsp;Fatching Closure Questions...
														</span>
													</template>
													<!-- if already collapsed -->
													<span v-if="showAvailableCQs">
														<font-awesome-icon :icon="['fas', 'minus']" title="cancel" fixed-width />&nbsp;Hide all available Closure Questions
													</span>
													<!-- collapse it -->
													<span v-else>
														<font-awesome-icon :icon="['fas', 'plus']" fixed-width />&nbsp;Show all available Closure Questions
													</span>
												</v-wait>
											</b-button>
										</b-col>
									</b-row>
								</b-card>
								<!-- 
									
									list of all available closure questions 
									+ new closure question form 
									
								-->
								<b-collapse v-model="showAvailableCQs" class="mt-4">
									<CQList
										:closureQuestions="notAssignedCQs"
										@assign="assignCQtoTemplate"
										:langauge_id="apt.language_id"
									></CQList>
								</b-collapse>
							</b-tab>
						</b-tabs>
						<!-- 
							
							action buttons 
							
						-->
						<b-form-group>
							<b-row class="mt-4 d-flex justify-content-end">
								<b-col cols="12" sm="12" md="7" lg="5">
									<b-button type="submit" :disabled="$wait.is('saving apt')" variant="success" block>
										<v-wait for="saving apt">
											<template slot="waiting">
												<span>
													<font-awesome-icon :icon="['fas', 'circle-notch']" spin />&nbsp;Saving...
												</span>
											</template>
											<font-awesome-icon :icon="['fas', 'save']" scale="5" />&nbsp;Save Template
										</v-wait>
									</b-button>
								</b-col>
							</b-row>
						</b-form-group>
					</fieldset>
				</b-form>
			</b-jumbotron>
		</transition>
	</b-container>
</template>

<script>
	import { mapState, mapActions } from "vuex";
	import pageLoader from "@/components/utils/wholePageLoader.vue";
	import regionEdit from "@/components/region/regionEdit.vue";
	import CQAssignetToTemplate from "@/components/closureQuestion/closureQuestionAssignetToTemplate.vue";
	import CQList from "@/components/closureQuestion/closureQuestionList.vue";
	import regionCreateForm from "@/components/region/regionCreateForm.vue";
	import transitionExpand from "@/components/utils/TransitionExpand.vue";
	import toast from "@/mixins/toast.js";
	import { orderBy, sortBy, flatMap, groupBy, map, differenceBy } from "lodash";
	import draggable from "vuedraggable";

	export default {
		name: "apTemplateEdit_view",

		// data
		data() {
			return {
				form: {
					enabled: false,
					closureOnly: false,
					language_id: "",
					description: "",
					questions: [], // got from db
					regions: [],
					closureQuestions: [],
				},
				questionsByRegion: {}, // computed, questions grouped by region.id {1:[{},{}...], 2:[]...}
				draggingRegions: false, // one of the refions is moving, show just the header of all regions (just cisiable help)
				cratingRegion: false,
				showAvailableCQs: false, // colapse area where all available closure questions appears
			};
		},

		// components
		components: {
			pageLoader,
			draggable,
			regionEdit,
			regionCreateForm,
			transitionExpand,
			CQAssignetToTemplate,
			CQList,
		},

		// mixins
		mixins: [toast],

		// computed
		computed: {
			// get apt
			...mapState("apTemplate", { apt: "item" }), // assignt template
			...mapState("closureQuestion", { cqs: "items" }), // assign closure-questions (list of all available)

			// after fething all questions, group them by thier region.id
			groupQuestionsByRegion() {
				// group
				let grouped = groupBy(this.apt.questions, "pivot.region_id");

				// sort by position field (db)
				for (var group in grouped) {
					grouped[group] = sortBy(grouped[group], "pivot.position");
				}

				return grouped;
			},

			// clicked on "show all avalible cqs", fetch all but filter/remove one that are already assignt
			notAssignedCQs() {
				return differenceBy(this.cqs, this.apt.closureQuestions, "id");
			},

			// is apt enabled
			isAPTEnabled() {
				return !!this.form.enabled;
			},
			// is closure only (no work report will be sent) enabled
			isClosureOnly() {
				return !!this.form.closureOnly;
			},

			// which tab should be shown
			tabIndex: {
				// getter
				get: function () {
					return this.isClosureOnly ? 1 : 0;
				},
				// setter
				set: function (newValue) {},
			}, // which main tab is shown

			// just the border color showing if the Template is enabled or disabled
			getBorderColor() {
				return this.isAPTEnabled ? "text-muted" : "text-warning";
			},
		},

		// methods
		methods: {
			// map vuex action to update the apt
			...mapActions("apTemplate", ["UPDATE_AP_TEMPLATE"]),
			// map vuex action to create region
			...mapActions("region", ["CREATE_REGION", "DELETE_REGION", "ADD_ITEM"]),

			// the REGION changed the position
			regionPositionMoved() {
				this.form.regions.map(function (item, index) {
					item.position = index + 1;
				});

				// dragging region stoped - deattach class from all regions (show their body)
				this.draggingRegions = false;
			},

			// dragging region started - attach class to all regions (hide their body)
			draggingRegion() {
				this.draggingRegions = true;
			},

			// the QUESTION changed the position, event triggered from copmonent
			doUpdateQuestionsOrder(regionId, questions) {
				this.questionsByRegion[regionId] = questions;
			},

			// region triggered event
			// add question to region
			doAddQuestion() {
				this.questionsByRegion = this.groupQuestionsByRegion;
			},

			// show new region form
			doAddRegion() {
				this.cratingRegion = !this.cratingRegion;
			},

			// submit new region to db
			doStoreNewRegion(region) {
				this.$wait.start("saving region");
				region.APTemplate_id = this.apt.id;
				region.position = this.form.regions.length + 1;
				this.CREATE_REGION({ data: region }).then(
					(region) => {
						// show OK feedback
						this.showToast("success", "Success", "The Region has been created.");
						this.form.regions.unshift(region);

						this.cratingRegion = false;

						// hide loader
						this.$wait.end("saving region");
					},
					(error) => {
						//console.log(error);
						// validation error
						if (error.status == 422) {
							this.showToast(
								"warning",
								error.statusText,
								JSON.stringify(error.data.errors)
							);
							// any other error
						} else {
							this.showToast("danger", error.statusText, error.data.message);
						}
						this.$wait.end("saving region");
					}
				);
			},

			// fuly remove region from db
			// & all ther relations (pivot) template-question where the region id
			doRemoveRegion(regionId) {
				// get ids of question within region, to be removed (pivot) together with region @backend
				const questionsId = map(this.questionsByRegion[regionId], "id");

				const data = {
					questionsId: questionsId,
					APTemplate_id: this.apt.id,
				};

				// go remove it
				this.DELETE_REGION({
					id: regionId,
					data: data,
				}).then(
					// true
					(response) => {
						this.form.regions = this.form.regions.filter(
							(item) => item.id != regionId
						);

						return response;
					},
					(error) => {
						// console.log("error", error);
						this.showToast("danger", error.statusText, error.data.message);
					}
				);
			},

			// get the list of all available closure questions
			getAvailableClosureQuestions() {
				if (this.showAvailableCQs) {
					this.showAvailableCQs = false;
					return;
				}

				this.$wait.start("loading cq");
				this.$store
					.dispatch("closureQuestion/GET_LIST", {
						language_id: this.apt.language_id,
					})
					.then(
						() => {
							this.$wait.end("loading cq");
							this.showAvailableCQs = true;
						},
						(error) => {
							this.showToast("danger", error.statusText, error.data.message);
							this.$wait.end("loading cq");
						}
					);
			},

			// add closure question to form.closureQuestion (assign to template)
			assignCQtoTemplate(cq) {
				cq.pivot = {
					APTemplate_id: this.apt.id,
					closureQuestion_id: cq.id || null,
					position: this.form.closureQuestions.length + 1,
				};
				this.form.closureQuestions.push(cq);
			},

			// remove closure question from form.closureQuestion (de assign from template)
			deAssignCQ(cq) {
				this.form.closureQuestions.shift(cq);
			},

			// order of closure questions changed, update parent
			doUpdateCLosureQuestionsOrder(cqs) {
				this.form.closureQuestions = cqs;
			},

			// the form has been submited
			onSubmit() {
				// flat the object
				// {0:[{question}, {question},...], 1:[{question}, {question},...]}  -> [{question},{question},...]
				this.form.questions = flatMap(this.questionsByRegion, function (q) {
					return q;
				});
				this.$wait.start("saving apt");

				// get the form data and submit it to backend
				this.UPDATE_AP_TEMPLATE({ data: this.form, id: this.apt.id }).then(
					(response) => {
						// show OK feedback
						this.showToast(
							"success",
							"Success",
							"The Template has been updated."
						);

						// hide loader
						this.$wait.end("saving apt");

						return response;
					},
					(error) => {
						// console.log(error);
						this.$wait.end("saving apt");
						this.showToast("danger", error.statusText, error.data.message);
					}
				);
			},
		},

		// created hook
		created() {
			this.$wait.start("loading apt");
		},

		// mounted hook
		mounted() {
			// get apt by his id
			this.$store
				.dispatch("apTemplate/GET_APT_BY_ID", { id: this.$route.params.id })
				.then(
					(apt) => {
						// assign apt data to form data
						this.form.description = apt.description;
						this.form.enabled = !!apt.enabled;
						this.form.closureOnly = !!apt.closureOnly;
						this.form.regions = orderBy(apt.regions, "position", "asc");
						this.form.questions = apt.questions;
						this.form.closureQuestions = apt.closureQuestions;
						this.questionsByRegion = this.groupQuestionsByRegion;
						this.form.language_id = apt.language_id || null;
						this.$wait.end("loading apt");
					},
					(error) => {
						this.showToast("danger", error.statusText, error.data.message);
						this.$wait.end("loading apt");
						if (error.status == 404) {
							this.$router.push("/404");
						}
					}
				);
		},
	};
</script>
<style>
	.region-container ~ .region-container {
		margin-top: 2.5rem;
	}
	/* .tab-select-wrapper {
																																																																																																																																																																																																																																																																																																																															margin-top: -37px;
																																																																																																																																																																																																																																																																																																																														} */
</style>